import * as ROUTES from '../common/routes';
import React from 'react';
import {
  StyleRules,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme: Theme): StyleRules =>
    createStyles({
      containerStyle: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
      },
      wrapperStyle: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        width: '100%',
        height: '100%',
      },
    })
);

const NotFound = (): JSX.Element => {
  const classes = useStyles();

  // const goHome = (event: React.SyntheticEvent) => {
  //   event.stopPropagation();
  //   event.preventDefault();

  //   history.push(ROUTES.ROOT);
  // };

  return (
    <div className={classes.containerStyle}>
      <div className={classes.wrapperStyle}></div>
    </div>
  );
};

export default NotFound;
